import React, {useEffect} from "react";
import stateMachine from "./ReprintPalletMachine";
import machineConfig from "./ReprintPalletMachineConfig";
import UIError from "../../../framework/util/uicomps/UIError";
import { useMachine } from "@xstate/react";
import ReprintPalletShowPallets from "./ReprintPalletShowPallets";
import UIStateStatus from "../../../framework/util/uicomps/UIStateStatus";
import ReprintPalletPrintManifest from "./ReprintPalletPrintManifest";
import ReprintPalletFinished from "./ReprintPalletFinished";
import FinishedPrintingManifest from "../FinishedPrintingManifest";

/**
 * Build pallet UI
 */
export const ReprintPalletUI = props => {

    /**
     * Connect to machine to react component using useMachine hook
     *
     * here currentState - is currentStatechart state object
     * sendEvent - function which will trigger statechart event when called
     */
    const [currentState, sendEvent] = useMachine(stateMachine, machineConfig);

    console.log('Current state', {currentState});

    return (
        <span>
            {
                currentState.matches("error") && (
                    <UIError currentState={currentState} sendEvent={sendEvent}/>
                )
            }
            {
                currentState.matches("showPallets") && (
                    <ReprintPalletShowPallets currentState={currentState} sendEvent={sendEvent}/>
                )
            }
            {
                currentState.matches("selectPrintOptions") && (
                   <ReprintPalletPrintManifest currentState={currentState} sendEvent={sendEvent}/>
                )
            }
            {
                currentState.matches("init") && (
                    <UIStateStatus message="Loading Pallets"/>
                )
            }
            {
                currentState.matches("generatingDatasource") && (
                    <UIStateStatus message="Refreshing Jobs In Pallet"/>
                )
            }
            {
                currentState.matches("printingManifest") && (
                    <UIStateStatus message="Sending Print Request"/>
                )
            }

            {
                currentState.matches("finished") && (
                    <FinishedPrintingManifest currentState={currentState} sendEvent={sendEvent}/>
                )
            }


            {/*<div>{currentState.context.status}</div>*/}
            {/*{JSON.stringify(currentState)}*/}

        </span>
    )
}

export default ReprintPalletUI;
